import { sharedEnvironment } from '@vinnova/environments';

const etjansterCommonApiBaseURI = `${sharedEnvironment.sys.gatewayUrl}/etjanster`;

export const environment = {
  production: sharedEnvironment.sys.production,
  name: sharedEnvironment.sys.name,
  ga4MeasurementId: sharedEnvironment.sys.ga4MeasurementId,
  etjansterCommonUrl: sharedEnvironment.sys.etjansterCommonUrl,
  bpUrl: sharedEnvironment.sys.bpUrl,
  ansokanUrl: sharedEnvironment.sys.ansokanUrl,
  projektUrl: sharedEnvironment.sys.projektUrl,
  cookieDomain: sharedEnvironment.sys.cookieDomain,
  etjansterCommonApiUrl: etjansterCommonApiBaseURI,
  projektApiUrl: `${sharedEnvironment.sys.gatewayUrl}/projekt`,
  resourceStringUrl: `${sharedEnvironment.sys.gatewayUrl}/resourcestring/etjanstercommon`,
  externalLinks: sharedEnvironment.sys.externalLinks,
  redirectUrls: [
    sharedEnvironment.sys.bpUrl,
    sharedEnvironment.sys.etjansterCommonUrl,
    sharedEnvironment.sys.enkatRegisterUrl,
    sharedEnvironment.sys.oregUrl,
    sharedEnvironment.sys.ansokanUrl,
  ],
  baseGatewayUrl: sharedEnvironment.sys.gatewayUrl,
  apimSubscriptionKey: sharedEnvironment.sys.apimSubscriptionKey,
  chatbotApiUrl: `${etjansterCommonApiBaseURI}/chatbot`,
  b2cMsalConfig: {
    ...sharedEnvironment.b2cMsalConfig(
      etjansterCommonApiBaseURI,
      sharedEnvironment.sys.azureAdB2C.clientId.etjansterCommonClientId,
      sharedEnvironment.sys.azureAdB2C.clientId.etjansterCommonApiClientId,
    ),
    authority: sharedEnvironment.sys.azureAdB2C.authority,
    scope: `https://${sharedEnvironment.sys.azureAdB2C.tenant}.onmicrosoft.com/${sharedEnvironment.sys.azureAdB2C.clientId.etjansterCommonApiClientId}/all`,
    tenant: sharedEnvironment.sys.azureAdB2C.tenant,
    policies: sharedEnvironment.sys.azureAdB2C.policies,
    clientId: sharedEnvironment.sys.azureAdB2C.clientId,
  },
};
